export const LineLeftArrow = () => (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.63642 15.6368C8.28495 15.9883 7.7151 15.9883 7.36363 15.6368L0.36363 8.63678C0.0121581 8.28531 0.0121582 7.71546 0.36363 7.36399L7.36363 0.363993C7.7151 0.0125207 8.28495 0.0125207 8.63642 0.363993C8.98789 0.715465 8.98789 1.28531 8.63642 1.63679L2.27282 8.00039L8.63642 14.364C8.98789 14.7155 8.98789 15.2853 8.63642 15.6368Z"
            fill="#818C99"
        />
    </svg>
);